import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";
import { setLoading } from "../loading/loadingSlice";
import authService from "../../Services/authService";

export const getLanguage = createAsyncThunk("getLanguage", async (_, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    let response;
    if (authService.getIsDoctorLogin() === "true") {
      response = await api.get(`/api/v1/doctor/profile/languages`);
    } else if (authService.getIsDoctorLogin() === "false") {
      response = await api.get(`/api/v1/hospital/manage/languages`);
    }
    return response.data;
  } catch (error) {
    console.error("Error fetching list:", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error fetching list";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});
export const getAllDepartment = createAsyncThunk("getDepartment", async (_, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    let response;
    if (authService.getIsDoctorLogin() === "true") {
      response = {};
    } else if (authService.getIsDoctorLogin() === "false") {
      response = await api.get(`/api/v1/hospital/manage/department`);
    }
    return response.data;
  } catch (error) {
    console.error("Error fetching list:", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error fetching list";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});
export const getHospitalPfp = createAsyncThunk("getHospitalProfile", async (_, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    let response;
    if (authService.getIsDoctorLogin() === "true") {
      response = await api.get(`/api/v1/doctor/profile/hospital`);
    } else if (authService.getIsDoctorLogin() === "false") {
      response = await api.get(`/api/v1/hospital/profile`);
    }
    return response.data;
  } catch (error) {
    console.error("Error fetching list:", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error fetching list";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});

// UPLOAD MEDIA
export const uploadMedia = createAsyncThunk("media/uploadMedia", async ({ files }, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const formData = new FormData();
    files.forEach((file) => {
      formData.append("files", file);
    });
    // const response = await api.post("/api/v1/media/user/upload", formData);
    let response;
    if (authService.getIsDoctorLogin() === "true") {
      response = await api.post(`/api/v1/doctor/profile/hospital`, formData);
    } else if (authService.getIsDoctorLogin() === "false") {
      response = await api.post(`/api/v1/media/doctor/upload`, formData);
    }
    return response.data;
  } catch (error) {
    console.error("Error uploading media:", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error uploading media";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});
// ADD DOCTOR
export const addDoctor = createAsyncThunk("addDoctor", async ({ sendData }, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    let response;
    if (authService.getIsDoctorLogin() === "true") {
      response = {};
    } else if (authService.getIsDoctorLogin() === "false") {
      response = await api.post(`/api/v1/hospital/manage/doctor`, sendData);
    }
    return response.data;
  } catch (error) {
    console.error("Error uploading media:", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error adding doctor";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});
// ADD DOCTOR
export const editDoctor = createAsyncThunk("editDoctor", async ({ sendData, _id }, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    let response;
    if (authService.getIsDoctorLogin() === "true") {
      response = await api.put(`/api/v1/doctor/profile`, sendData);
    } else if (authService.getIsDoctorLogin() === "false") {
      response = await api.put(`/api/v1/hospital/manage/doctor/${_id}`, sendData);
    }
    return response.data;
  } catch (error) {
    console.error("Error editing media:", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error editing doctor";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});
// DELETE DOCTOR
export const deleteDoctor = createAsyncThunk("deleteDoctor", async ({ _id }, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    let response = await api.delete(`/api/v1/hospital/manage/doctor/${_id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting media:", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error deleting doctor";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});
